import React, { Component } from "react";
import Datas from "../../data/event/details.json";

import { Container, Row, Col } from "react-bootstrap";

import { Styles } from "./styles/events.js";

import { BreadcrumbBox } from "../../components/common/Breadcrumb.js";

import HeaderTwo from "../../components/HeaderTwo.js";
import FooterTwo from "../../components/FooterTwo.js";
import PopularTransportation from "../../components/facilities/PopularTrasportation.js";

class Transportation extends Component {
  render() {
    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper event-details-page">
          {/* Header 2 */}
          <HeaderTwo />

          {/* Breadcrumb */}
          <BreadcrumbBox title="Transportation" />

          {/* Transportation Details Area */}
          <section className="event-details-area">
            <Container>
              <Row>
                <Col lg="9" md="8" sm="12">
                  <div className="event-details-content">
                    <div className="heading">
                      <h4>Safe & Reliable School Transportation</h4>
                    </div>
                    <div className="event-icon">
                      <ul className="list-unstyled list-inline">
                        <li className="list-inline-item">
                          <i className="las la-bus"></i> Well-maintained School Buses
                        </li>
                        <li className="list-inline-item">
                          <i className="las la-user-shield"></i> Trained & Certified Drivers
                        </li>
                        <li className="list-inline-item">
                          <i className="las la-clock"></i> Punctual Pick-up & Drop-off
                        </li>
                      </ul>
                    </div>
                    <div className="event-details-banner">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          `/assets/images/bus.jpg`
                        }
                        alt="School Transportation"
                        className="img-fluid"
                      />
                    </div>
                    <div className="event-details-overview">
                      <h5>Transportation Overview</h5>
                      <p>
                      Our school offers a safe, reliable, and well-organized transportation system, ensuring that students travel comfortably and securely to and from school. Our fleet of well-maintained buses is regularly inspected for safety and hygiene, providing a clean and comfortable travel experience. Each bus is operated by highly trained drivers and responsible staff members who prioritize student safety, maintain discipline, and offer assistance throughout the journey. With a focus on efficiency, punctuality, and security, we strive to make daily commutes stress-free for both students and parents.
                      </p>
                      <ul className="list-unstyled">
                        <li>
                          <i className="fa fa-check"></i>
                          <span> Our school transportation service operates on well-planned routes that cover all major city areas and residential neighborhoods, ensuring convenient access for student. </span>
                        </li>
                        <li>
                          <i className="fa fa-check"></i>
                          <span> Each bus is operated by a professionally trained driver and an onboard staff member who prioritizes student safety, maintains discipline, and provides assistance during the journey. </span>
                        </li>
                        <li>
                          <i className="fa fa-check"></i>
                          <span> All school buses undergo routine inspections, servicing, and thorough hygiene checks to ensure a safe, comfortable, and sanitary travel environment for students. </span>
                        </li>
                     
                      </ul>
                    </div>
                    <div className="event-details-speaker">
                      <h5>Our Transport Staff</h5>
                      <Row>
                        {Datas.map((data, i) => (
                          <Col lg="3" md="6" sm="6" key={i}>
                            <div className="event-speaker-item">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  `/assets/images/${data.personImage}`
                                }
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                    <div className="event-details-overview">
                      {/* <h5>Transportation Committee</h5> */}
                      {/* <div>
                        <ul className="list-unstyled">
                          <li>
                            <i className="fa">1</i>
                            <span className="font-weight-bold"> Mr. Ramesh Iyer </span>
                            <br />
                            <span>Transportation Manager</span>
                          </li>
                        </ul>
                        <ul className="list-unstyled">
                          <li>
                            <i className="fa">2</i>
                            <span> Ms. Sunita Rao </span>
                          </li>
                        </ul>
                        <ul className="list-unstyled">
                          <li>
                            <i className="fa">3</i>
                            <span> Mr. Arvind Mehta </span>
                          </li>
                        </ul>
                        <ul className="list-unstyled">
                          <li>
                            <i className="fa">4</i>
                            <span> Ms. Leela Menon </span>
                          </li>
                        </ul>
                      </div> */}
                    </div>
                  </div>
                </Col>
                <Col lg="3" md="4" sm="12">
                  <div className="event-details-sidebar">
                    <Row>
                      <Col md="12">
                        <div className="event-sidebar-info">
                          <ul className="list-unstyled event-info-list">
                      
                            <li>Coverage: <span>City & Suburbs</span></li>
                            <li>Safety Measures: <span>Trained Staff</span></li>
                            <li>Student Capacity: <span>40-50 per Bus</span></li>
                            <li>Timings: <span>Morning & Evening</span></li>
                            <li>Emergency Support: <span>Available</span></li>
                          </ul>
                        </div>
                      </Col>
                      <Col md="12">
                        <PopularTransportation />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Footer 2 */}
          <FooterTwo />
        </div>
      </Styles>
    );
  }
}

export default Transportation;
